import { render, staticRenderFns } from "./px-matching-interest-compact.vue?vue&type=template&id=7a18f8b5&scoped=true&"
import script from "./px-matching-interest-compact.vue?vue&type=script&lang=ts&"
export * from "./px-matching-interest-compact.vue?vue&type=script&lang=ts&"
import style0 from "./px-matching-interest-compact.vue?vue&type=style&index=0&id=7a18f8b5&lang=scss&scoped=true&"
import style1 from "./px-matching-interest-compact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a18f8b5",
  null
  
)

export default component.exports